import styled from "styled-components";

import { colorsPalettes, setFontVariant, truncateText } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";

export const StyledAdditionalLabel = styled.div`
    ${setFontVariant("tooltip", colorsPalettes.carbon[250])}
    margin-left: 15px;
    overflow: hidden;
`;

export const StyledTextWrapper = styled.div`
    width: 100%;
    display: flex;
    & span {
        white-space: pre;
    }
`;

export const StyledEllipsisDropdownItem = styled(EllipsisDropdownItem)<{
    type: string;
    alias: string;
    subText?: string;
}>`
    display: flex;

    > div:first-child {
        flex: 1 0;

        > div {
            flex: 1;
        }
    }

    & ${StyledTextWrapper} {
        max-width: calc(100% - 24px);
    }
`;

export const StyledDropdown = styled.div`
    & .DropdownContent-container {
        position: static;
        margin-top: 1px;
        width: 670px !important;
    }
`;

export const StyledHighlight = styled.span`
    background: ${colorsPalettes.blue[100]};
    white-space: pre;
`;
export const StyledTech = styled.div`
    &:before {
        content: "| ";
    }
`;

export const StyledExample = styled.div`
    ${truncateText()}
    &:before {
        content: "( e.g. ";
    }
    &:after {
        content: ")";
    }
`;
